module.exports = __webpack_public_path__ + "img/discountCoupon.864c363f.png";